var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Info_svgr__b{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-513 -1673)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(513 1673)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Info_svgr__b",
    d: "M519 1679h2v5h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Info_svgr__b",
    d: "M518 1679h2v1h-2z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Info_svgr__b",
    width: 2,
    height: 2,
    rx: 1,
    transform: "translate(519 1676)"
  }))));
};

export default SvgInfo;